import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';

export const OverlayCaption: StyleRule = () => ({
    background: 'rgba(0,0,0,0.5)',
    padding: pxArrayToRem([6, 12]),
    boxShadow: `0px 14px 24px 2px rgba(0, 0, 0, 0.08)`,
    width: '100%',
});
